// @ts-nocheck
/* eslint-disable */
export const elioArrowUpIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 40 40"><defs><style>.arrow_up_svg__a{clip-path:url(#arrow_up_svg__b)}</style><clipPath id="arrow_up_svg__b"><rect width="40" height="40"/></clipPath></defs><g id="arrow_up_svg__a" class="arrow_up_svg__a"><path d="M16,4l2.115,2.115L9.745,14.5H28v3H9.745l8.37,8.385L16,28,4,16Z" transform="translate(36 4) rotate(90)"/></g></svg>`,
    name: 'arrow-up' as const
};